import React, { Component } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { connect } from 'react-redux';

import AppliedRoute from './components/AppliedRoute';
import AuthenticatedRoute from './components/AuthenticatedRoute';

import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import ForgotPasswordSubmit from './pages/ForgotPasswordSubmit';
import Home from './pages/Home';
import Scheduling from './pages/Scheduling';
import Menus from './pages/Menus';
import LaunchPdfExport from './pages/LaunchPdfExport';

import Admin from './pages/Admin/Admin';

import './App.css';
import './css/bootstrap-overrides.css';
import NewMenu from './pages/NewMenu';
import NewMenuMeals from './pages/NewMenu/Meals';
import EditMenu from './pages/EditMenu/EditMenu';
import Gallery from './pages/Gallery';
import RoomGallery from './pages/RoomGallery';
import ChildGallery from './pages/ChildGallery';
import Events from './pages/Events';
import Messages from './pages/Messages/routes/Messages';
import CenterGallery from './pages/CenterGallery';
import ManagerOverview from './pages/Messages/routes/ManagerOverview/ManagerOverview';
import EmployeeAttendance from './pages/Attendance/Employee/EmployeeAttendanceToday';
import EmployeeAttendanceRange from './pages/Attendance/Employee/EmployeeAttendanceRange';
class App extends Component {
  componentDidMount = async () => {
    try {
      const session = await Auth.currentSession();

      if (session) {
        let userPayload = session.idToken.payload;
        const username = userPayload['cognito:username'];

        userPayload = { ...userPayload, username };
        console.log(userPayload);
        this.props.setUser(userPayload);
      }
    } catch (e) {
      console.log(e);
      if (e !== 'No current user') {
      }
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.loggedIn && !this.props.loggedIn) {
      window.location.replace('/');
    }
  }

  handleLogout = (event) => {
    this.props.logout();
  }

  render () {
    return (
      <Router>
        <Switch>
          <AppliedRoute path='/' exact component={Login} />
          <AppliedRoute path='/login' exact component={Login} />
          <AppliedRoute
            path='/change-password'
            exact
            component={ChangePassword}
          />
          <AppliedRoute
            path='/forgot-password'
            exact
            component={ForgotPasswordSubmit}
          />

          <AuthenticatedRoute path='/home' exact component={Home} />
          <AuthenticatedRoute path='/scheduling' exact component={Scheduling} />
          <AuthenticatedRoute
            path='/admin'
            exact
            component={Admin}
          />
          <AuthenticatedRoute
            path='/launch-pdf-export'
            exact
            component={LaunchPdfExport}
          />
          <AuthenticatedRoute
            path='/home'
            exact
            component={Home}
          />
          { this.props.featureFlagMenus
            ? <AuthenticatedRoute
              path='/menus'
              exact
              component={Menus}
            />
            : null }
          { this.props.featureFlagMenus
            ? <AuthenticatedRoute
              path='/menus/new'
              exact
              component={NewMenu}
            /> : null
          }
          { this.props.featureFlagMenus
            ? <AuthenticatedRoute
              path='/menus/new/meals'
              exact
              component={NewMenuMeals}
            /> : null
          }
          { this.props.featureFlagMenus
            ? <AuthenticatedRoute
              path='/menus/:menu_id/edit'
              exact
              component={EditMenu}
            /> : null
          }
          { this.props.featureFlagGallery
            ? <AuthenticatedRoute
              path='/gallery'
              exact
              component={Gallery}
            /> : null
          }
          { this.props.featureFlagGallery
            ? <AuthenticatedRoute
              path='/gallery/room/:room_id'
              exact
              component={RoomGallery}
            /> : null
          }
          { this.props.featureFlagGallery
            ? <AuthenticatedRoute
              path='/gallery/room/:room_id/child/:child_id'
              exact
              component={ChildGallery}
            /> : null
          }
          { this.props.featureFlagGallery
            ? <AuthenticatedRoute
              path='/gallery/center/:center_id'
              exact
              component={CenterGallery}
            /> : null
          }
          { this.props.featureFlagEvents
            ? <AuthenticatedRoute
              path='/events'
              exact
              component={Events}
            /> : null
          }
          { this.props.featureFlagMessaging
            ? <AuthenticatedRoute
              path='/messages'
              exact
              component={Messages}
            /> : null
          }
          { this.props.featureFlagMessaging
            ? <AuthenticatedRoute
              path='/messages/overview'
              exact
              component={ManagerOverview}
            /> : null
          }
          { this.props.featureFlagEmployeeAttendance
            ? <AuthenticatedRoute
              path='/attendance/employee'
              exact
              component={EmployeeAttendance}
            /> : null
          }
          { this.props.featureFlagEmployeeAttendance
            ? <AuthenticatedRoute
              path='/attendance/employee/:employee_id'
              exact
              component={EmployeeAttendanceRange}
            />
            : null
          }
        </Switch>
      </Router>
    );
  }
}

function mapStateToProps (state) {
  return {
    loggedIn: state.authentication.loggedIn,
    featureFlagMenus: state.identity.flags.menus,
    featureFlagGallery: state.identity.flags['new-gallery'],
    featureFlagScheduling: state.identity.flags['new-scheduling'],
    featureFlagEvents: state.identity.flags['new-events'],
    featureFlagMessaging: state.identity.flags['new-messaging'],
    featureFlagEmployeeAttendance: state.identity.flags['new-employee-attendance']
  };
}

function mapDispatchToProps (dispatch) {
  return {
    logout: () =>
      dispatch({
        type: 'LOGOUT_REQUEST'
      }),
    setUser: user =>
      dispatch({
        type: 'SET_USER_FROM_SESSION',
        user
      })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
